import { useState, useEffect,useRef } from "react";
import { Box, Button, Typography,Grid } from "@mui/material";
import { useReactToPrint } from "react-to-print";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../../AuthProvider";

const baseUrl = process.env.REACT_APP_API_BASE_URL;

const ProgressCard2 = () => {
  const componentRef = useRef();
  const navigate = useNavigate();
  const { oId, board, pId } = useAuth();
  const studentProgress = JSON.parse(sessionStorage.getItem("studentProgress"));
  const studentResults = JSON.parse(sessionStorage.getItem("studentResult"));

  sessionStorage.setItem("studentProgress", JSON.stringify(studentResults));

  const [studentInfo, setStudentInfo] = useState(null);
  const [subjectMarks, setSubjectMarks] = useState([]);

   const [attendanceData, setAttendanceData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [overallWorkingDays, setOverallWorkingDays] = useState(0);
  const [overallPresentDays, setOverallPresentDays] = useState(0);
  
function generateColor(index) {
  const hue = (index * 60) % 360; // shift hues around the color wheel
  return `hsl(${hue}, 60%, 75%)`; // pastel-like colors
}

const categories = Array.from(
  new Set(
    subjectMarks.flatMap((subj) =>
      subj.categories?.map((cat) => cat.subjectsCategory) || []
    )
  )
).map((title, index) => ({
  title,
  color: generateColor(index), // 🎨 auto-generate
}));

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "ProgressCard2",
  });

 // ✅ Fetch Student Marks
   const fetchData = async () => {
     if (!oId || !pId || !studentProgress?.studentId || !studentProgress?.type) {
       console.warn("Missing oId, pId, or studentProgress");
       return;
     }
 
     try {
       const url = `${baseUrl}/api/subjectMarks/getStudentReportCard/${studentProgress.studentId}/${oId}/${pId}?examType=${studentProgress.type}`;
       const response = await fetch(url);
       if (!response.ok) {
         console.error("API Error:", response.status, response.statusText);
         return;
       }
       const data = await response.json();
       if (data) {
         const { subjects, ...rest } = data;
         setStudentInfo(rest);
         setSubjectMarks(subjects || []);
       }
     } catch (error) {
       console.error("Error fetching student data:", error);
     }
   };
 
   useEffect(() => {
     if (oId && pId && studentProgress?.studentId && studentProgress?.type) {
       fetchData();
     }
   }, [oId, pId, studentProgress?.studentId, studentProgress?.type]);

   const [companyInfo, setCompanyInfo] = useState({
            schoolName: "",
            pincode: "",
            primaryContact: "",
            secondaryContact: "",
            boardAffiliation: "",
            schoolAddress: "",
            affiliationNumber: "",
            city: "",
            state: "",
            schoolEmailId: "",
            schoolLogo: "",
            schoolStamp: "",
          });
          //organization details api 
                    useEffect(() => {
                      const fetchCompanyInfo = async () => {
                        try {
                          const response = await fetch(`${baseUrl}/api/v1/organisation/${oId}`);
                          if (!response.ok) {
                            throw new Error("Network response was not ok");
                          }
                          const data = await response.json();
                          setCompanyInfo({
                            schoolLogo: data.schoolLogo,
                            schoolStamp:data.schoolStamp,
                            schoolName: data.schoolName,
                            city: data.city,
                            state: data.state,
                            affiliationNumber: data.affiliationNumber,
                            schoolAddress: data.schoolAddress,
                            primaryContact: data.primaryContact,
                            boardAffiliation: data.boardAffiliation,
                            secondaryContact: data.secondaryContact,
                            pincode: data.pincode,
                            schoolEmailId: data.schoolEmailId,
                          });
                        } catch (error) {
                          console.error("Error fetching company info:", error);
                         
                        }
                      };
                  
                      fetchCompanyInfo();
                    }, []);

                    const formatExamType = (type) => {
  if (!type) return "";

  const parts = type.trim().toUpperCase().split("-");

  if (parts.length !== 2) return type;

  const [prefix, number] = parts;

  switch (prefix) {
    case "FA":
      return `Formative Assessment - ${number}`;
    case "SA":
      return `Summative Assessment - ${number}`;
    default:
      return type;
  }
};

//ATTENDANCE api 
 useEffect(() => {
    const fetchAttendance = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${baseUrl}/api/montlyReports/getMontlyReportsReportCard/1?examType=${studentProgress?.type}&studentId=${studentProgress?.studentId}`
        );
        const data = await response.json();

        if (data && data.months) {
          const monthArray = data.months.split(","); // ["January","February"]
          const formattedData = monthArray.map((month) => ({
            month,
            workingDays: data.monthDaysMap[month] || 0,
            presentDays: data.presentDaysMap[month] || 0,
          }));

          setAttendanceData(formattedData);
          setOverallWorkingDays(data.overAllWorkingDays || 0);
          setOverallPresentDays(data.overAllPresentDays || 0);
        } else {
          setAttendanceData([]);
          setOverallWorkingDays(0);
          setOverallPresentDays(0);
        }
      } catch (error) {
        console.error("Error fetching attendance data:", error);
        setAttendanceData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchAttendance();
  }, [ studentProgress?.studentId, studentProgress?.type]);


  return (
    <Box
      sx={{
        backgroundColor: "#f9fafb",
        padding: "2rem",
        borderRadius: "1rem",
        boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
        width: "97%",
        margin: "5% 20px 20px 20px",
        border: "1px solid #D1D5DB",
      }}
    >
      {/* Header with back + print */}
      <Box
        sx={{
          marginBottom: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
  <Button onClick={() => navigate(-1)} sx={{ color: "#2e2a54", minWidth: "auto", p: 0.5 }}>
    <KeyboardBackspaceIcon fontSize="medium" />
  </Button>
  <Typography
    variant="h4"
    component="h3"
    sx={{ fontWeight: "bold", marginLeft: 0.5 }} // reduced gap
  >
    Student Report Card
  </Typography>
</Box>
        <Button
          variant="contained"
           sx={{
            backgroundColor: "#3C3972",
            color: "white",
            "&:hover": {
              backgroundColor: "#3C3972",
            },
          }}
          onClick={handlePrint}
        >
          Print
        </Button>
      </Box>

      {/* Report Card */}
     <Box ref={componentRef} className="report-card">
  <style>
  {`
    .report-card {
      padding: 10px;
      font-family: Arial, sans-serif;
    }

    .school-name {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 8px;
  text-transform: uppercase;
  color: #0d47a1; /* deep blue, looks nice */
}

.header-container {
  margin-bottom: 12px;
}
    .header-banner {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;
    }

    /* Left Side - Student Info */
    .student-details {
      font-weight: normal;
      font-size: 16px;
      color: #000; /* Black text */
    }

    /* Right Side - Title with red background */
    .title-banner {
      background: #b21f35;
      color: #fff;
      font-weight: bold;
      padding: 6px 12px;
      border-radius: 5px;
      font-size: 18px;
    }

    .subjects-table, .attendance {
      width: 100%;
      border-collapse: collapse;
      margin-bottom: 15px;
    }

    .subjects-table th, .subjects-table td,
    .attendance th, .attendance td {
      border: 1px solid #000;
      text-align: center;
      padding: 6px;
      font-size: 14px;
    }

    .attendance-title {
      background: #d6c813;
      font-weight: bold;
      text-transform: uppercase;
    }

    .highlight {
      font-weight: bold;
      color: darkmagenta;
      text-align: left;
      padding-left: 10px;
    }

    .remarks {
  border: 1px solid #000;
  margin-bottom: 15px;
  font-size: 14px;
  display: flex;
}

.remarks-row {
  display: flex;
  flex: 1;

}

.remarks-title {
  font-weight: bold;
   width: 70px; /* fixed width */
  border-right: 1px solid #000;
  display: flex;
  align-items: center; /* center vertically */
  justify-content: flex-start;
  padding-left: 0 4px; /* only left padding */
  min-width: max-content;
   align-self: stretch;
}

.remarks-value {
  flex: 1;
  padding: 2px;
  min-height: 50px; /* keeps box height */
}

  `}
</style>
{/* Header (School Name + Student Details + Title) */}
<div className="header-container">

  {/* School Name - Top Center */}
   <Box display="flex" justifyContent="space-between" alignItems="center">
                      <Box width="20%" marginTop="10px">
                        <img
                          src={`data:image/jpeg;base64,${companyInfo.schoolLogo}`}
                          alt="Logo"
                          style={{
                            width: "80px",         // Set a single value
                            height: "80px",        // Match the width exactly
                            borderRadius: "50%",    // Ensures circle
                            objectFit: "cover",     // Ensures image fills without distortion
                          }}
                        />
            
                      </Box>
                      <Box textAlign="center" flexGrow={1}>
                         <Grid item xs={12} sm={8}>
                                                        <Grid container direction="column" spacing={1}>
                                                          <Grid item>
                                                            <Typography variant="h3" style={{ fontWeight: "bold", color: "red" }}>
                                                              {companyInfo.schoolName}
                                                            </Typography>
                                                          </Grid>
  
                                                          <Grid item>
                                                            <Typography variant="h5" style={{ fontWeight: "bold", }}>
                                                            {formatExamType(studentInfo?.examType)}
                                                            </Typography>
                                                          </Grid>
                                                        </Grid>
                                                      </Grid>
                      </Box>
                      <Box width="20%" />
            </Box>

{/* Header (Student Details + Title) */}
<div className="header-banner">
  <Grid item xs={6}>
                  <Typography variant="body1">
                    <strong>Name:</strong> {studentProgress?.firstName} {studentProgress?.lastName}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                                  <Typography variant="body1">
                                    <strong>Roll No:</strong> {studentInfo?.studentRollNumber || "N/A"}
                                  </Typography>
                                </Grid>

                                 <Grid item xs={6}>
                                                  <Typography variant="body1">
                                                    <strong>{board === "INTERMEDIATE" ? "Year:" : "Class:"}</strong> {studentInfo?.romanNumberClass}
                                                  </Typography>
                                                </Grid>
                                              {(board === "INTERMEDIATE") &&(
                                                <Grid item xs={6}>
                                                  <Typography variant="body1">
                                                    <strong>Course:</strong> {studentInfo?.course}
                                                  </Typography>
                                                </Grid>
                                              )}
                                                <Grid item xs={6}>
                                                  <Typography variant="body1">
                                                    <strong>Section:</strong> {studentInfo?.sections}
                                                  </Typography>
                                                </Grid> 
</div>
</div>

  {/* Subjects Table */}
 <table className="subjects-table">
          <thead>
  <tr>
    <th style={{ backgroundColor: "#fff9c4" }}>S. NO</th>
    <th>SUBJECTS</th>

    {categories.map((head, index) => {
      // ✅ pick totalMarks from the *first subject* that has this category
      const total = subjectMarks[0]?.categories?.find(
        (c) => c.subjectsCategory === head.title
      )?.totalMarks;

      return (
       <th
      key={index}
      style={{
        backgroundColor: head.color,
        whiteSpace: "pre-line",  // allows line break
      }}
    >
      {head.title}{"\n"}({total ?? ""})
    </th>
      );
    })}

    <th
  rowSpan="2"
  style={{
    backgroundColor: "#a0d4adff",
    whiteSpace: "pre-line", // allows text on new line
  }}
>
  TOTAL{"\n"}
  ({studentInfo?.totalMarks ?? ""})
</th>
    <th style={{ backgroundColor: "#b2b974ff" }}>GRADE</th>
  </tr>
</thead>
          <tbody>
            {subjectMarks.map((subj, index) => (
              <tr key={subj.subjectId}>
                <td style={{ backgroundColor: "#fff9c4", color: "blue" }}>
                  {index + 1}
                </td>
                <td style={{ backgroundColor: "#fff9c4", color: "blue" }}>
                  {subj.subject}
                </td>
                {categories.map((cat, i) => {
                  const found = subj.categories.find(
                    (c) => c.subjectsCategory === cat.title
                  );
                  return <td key={i}>{found?.obtainedMarks ?? ""}</td>;
                })}
                <td>{subj.marks}</td>
                <td>{subj.grade}</td>
              </tr>
            ))}

            {/* Grand Total */}
            <tr>
  <td colSpan="2" className="highlight">
    Grand Total
  </td>

  {categories.map((_, i) => (
    <td key={i}></td>
  ))}

  {/* ✅ Obtained Marks from API */}
<td>
  <strong>{studentInfo?.obtainedMarks ?? ""}</strong>
</td>

{/* ✅ Overall Grade from API */}
<td>
  <strong>{studentInfo?.overallGrade ?? ""}</strong>
</td>
</tr>

          </tbody>
        </table>

  {/* Attendance Table */}
<table className="attendance">
  <thead>
    <tr>
      <th style={{ width: "190px" }}>ATTENDANCE</th>
      <th>MONTHS</th>
      <th>NO. OF WORKING DAYS</th>
      <th>NO. OF DAYS PRESENT</th>
    </tr>
  </thead>
  <tbody>
    {attendanceData && attendanceData.length > 0 ? (
      <>
        {/* First row with image */}
        <tr style={{ height: "40px" }}>
          <td
            rowSpan={attendanceData.length + 1}
            style={{
              textAlign: "center",
              verticalAlign: "middle",
              padding: 0,
            }}
          >
            <img
              src="https://www.eurokidsindia.com/blog/wp-content/uploads/2023/07/engage-in-learning-870x570.jpg"
              alt="Children"
              style={{
                width: "190px",
                height: `${(attendanceData.length + 1) * 40}px`, // dynamic height
                objectFit: "cover",
                display: "block",
              }}
            />
          </td>
          <td style={{ backgroundColor: "#fff9c4" }}>{attendanceData[0].month}</td>
          <td style={{ backgroundColor: "#fff9c4" }}>{attendanceData[0].workingDays}</td>
          <td style={{ backgroundColor: "#fff9c4" }}>{attendanceData[0].presentDays}</td>
        </tr>

        {/* Rest of the months */}
        {attendanceData.slice(1).map((item, index) => (
          <tr key={index} style={{ height: "40px" }}>
            <td style={{ backgroundColor: "#fff9c4" }}>{item.month}</td>
            <td style={{ backgroundColor: "#fff9c4" }}>{item.workingDays}</td>
            <td style={{ backgroundColor: "#fff9c4" }}>{item.presentDays}</td>
          </tr>
        ))}

        {/* Total row */}
        <tr style={{ height: "40px", fontWeight: "bold" }}>
          <td className="highlight">Total</td>
          <td style={{ backgroundColor: "#fff9c4" }}>{overallWorkingDays}</td>
          <td style={{ backgroundColor: "#fff9c4" }}>{overallPresentDays}</td>
        </tr>
      </>
    ) : (
      <>
        {/* Default image and 3 placeholder rows */}
        <tr style={{ height: "40px" }}>
          <td
            rowSpan="4"
            style={{
              textAlign: "center",
              verticalAlign: "middle",
              padding: 0,
            }}
          >
            <img
              src="https://www.eurokidsindia.com/blog/wp-content/uploads/2023/07/engage-in-learning-870x570.jpg"
              alt="Children"
              style={{
                width: "190px",
                height: `${4 * 40}px`, // 4 rows including total
                objectFit: "cover",
                display: "block",
              }}
            />
          </td>
          <td style={{ backgroundColor: "#fff9c4" }}>-</td>
          <td style={{ backgroundColor: "#fff9c4" }}>-</td>
          <td style={{ backgroundColor: "#fff9c4" }}>-</td>
        </tr>
        <tr style={{ height: "40px" }}>
          <td style={{ backgroundColor: "#fff9c4" }}>-</td>
          <td style={{ backgroundColor: "#fff9c4" }}>-</td>
          <td style={{ backgroundColor: "#fff9c4" }}>-</td>
        </tr>
        <tr style={{ height: "40px" }}>
          <td style={{ backgroundColor: "#fff9c4" }}>-</td>
          <td style={{ backgroundColor: "#fff9c4" }}>-</td>
          <td style={{ backgroundColor: "#fff9c4" }}>-</td>
        </tr>
        <tr style={{ height: "40px" }}>
          <td className="highlight">Total</td>
          <td style={{ backgroundColor: "#fff9c4" }}>-</td>
          <td style={{ backgroundColor: "#fff9c4" }}>-</td>
        </tr>
      </>
    )}
  </tbody>
</table>




  {/* Remarks Section */}
 <div class="remarks">
  <div class="remarks-row">
    <div class="remarks-title">Remarks</div>
    <div class="remarks-value"></div>
  </div>
</div>

  <div style={{ display: "flex", justifyContent: "space-between", marginTop: "30px" }}>
  <div style={{ textAlign: "left" }}>Class Teacher</div>
  <div style={{ textAlign: "center", flex: 1 }}>Principal / H.M.</div>
  <div style={{ textAlign: "right" }}>Parent / Guardian</div>
</div>
</Box>
      {/* Inline CSS */}
      <style>{`
        .report-card {
          border: 4px solid pink;
          padding: 10px;
          width: 800px;
          margin: auto;
          background: white;
        }
        .title {
          text-align: center;
          font-weight: bold;
          font-size: 20px;
          margin-bottom: 10px;
          background: #f3f3f3;
          padding: 5px;
        }
        table {
          border-collapse: collapse;
          width: 100%;
          margin-bottom: 15px;
        }
        th, td {
          border: 1px solid black;
          text-align: center;
          padding: 6px;
          font-size: 14px;
        }
        th {
          background: #f9d6f9;
          font-weight: bold;
        }
        .vertical-text {
          writing-mode: vertical-rl;
          transform: rotate(180deg);
          font-weight: bold;
          font-size: 12px;
        }
        .attendance {
          margin-top: 20px;
          border: 1px solid black;
        }
        .attendance th {
          background: #70c0ceff;   /* 🔴 changed from #dcdcdc */
          color: #fff;           /* white text for contrast */
          font-weight: bold;
        }
        .remarks {
          border: 1px solid black;
          height: 60px;
          margin-top: 10px;
          padding: 5px;
        }
        .footer {
          display: flex;
          justify-content: space-between;
          margin-top: 20px;
        }
           /* ✅ Print specific padding */
 @media print {
  .report-card {
    margin: 40px auto !important;  /* top-bottom, auto left/right */
    width: 700px;                  /* keep smaller than page */
  }
}

      `}</style>
    </Box>
  );
};

export default ProgressCard2;